export function birthDateToNumber(date: Date) {
  return `${date.getFullYear()}${date.getMonth()}${date.getDay()}`;
}
